import iCaret from "../../../../assets/icons/caret-down.svg";
import { ReactNode, useState } from "react";
import "./accordion-item-primary.sass";

type Props = {
  children: ReactNode | ((isOpen: boolean) => ReactNode);
  title: string;
  id?: string;
  unmountOnClose?: boolean;
};

const AccordionItemPrimary = ({
  title,
  children,
  id,
  unmountOnClose = false,
}: Props) => {
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  const resolvedChildren =
    typeof children === "function" ? children(isOpen) : children;
  const content = unmountOnClose
    ? isOpen
      ? resolvedChildren
      : null
    : resolvedChildren;

  return (
    <div className="accordion-item-primary" id={id}>
      <div className="accordion-item-primary__upper" onClick={handleOpen}>
        <div className="accordion-item-primary__title">{title}</div>

        <img
          src={iCaret}
          className={`accordion-item-primary__caret ${
            isOpen ? "accordion-item-primary__caret--open" : ""
          }`}
          alt=""
        />
      </div>

      <div
        className={`accordion-item-primary__content accordion-item-primary__content${
          isOpen ? "--open" : "--closed"
        }`}
      >
        {content}
      </div>
    </div>
  );
};

export default AccordionItemPrimary;
